module.exports = __webpack_public_path__ + "img/Allec-New-Logo-W.96e7ab70.png";